/**
 * Delegated handler for [data-share-button]: Web Share API with clipboard fallback.
 */
(function shareButtonInit() {
  if (document.documentElement.dataset.shareButtonDelegation === 'true') {
    return;
  }
  document.documentElement.dataset.shareButtonDelegation = 'true';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-share-button]');
    if (!button) {
      return;
    }

    const { shareUrl, shareTitle } = button.dataset;
    const url = shareUrl || window.location.href;
    const title = shareTitle || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (err) {
        if (err && err.name === 'AbortError') {
          return;
        }
      }
    }

    await copyUrlToClipboard(button, url);
  });

  /**
   * @param {HTMLButtonElement} button
   * @param {string} url
   */
  async function copyUrlToClipboard(button, url) {
    const copiedMessage = button.getAttribute('data-share-copied-announcement') || 'Link copied';
    const originalLabel = button.getAttribute('aria-label');

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      if (originalLabel !== null) {
        button.setAttribute('aria-label', copiedMessage);
        window.setTimeout(() => {
          button.setAttribute('aria-label', originalLabel);
        }, 2500);
      }
    } catch {
      /* noop */
    }
  }
})();
